import {setErrorMessageAction, unsetErrorMessageAction, setShippingOptionsAction, unsetShippingOptionsAction}
    from '../../_flux/actions/product_mixed_stocks_lightbox_actions';
import shippingOptionsComputeRequest from '../../_flux/components/product/product_mixed_stocks_shipping_options_compute_request';
import {hideAction as unlockUi, showAction as lockUi} from '../../_flux/actions/ui_lock_actions';
import Cart from '../../_flux/stores/models/cart';

export default function onCartShippingOptionSelectComputeRequest(cart) {
    const errorMessage = 'product-mixed-stocks-shipping-option-compute-failed';
    if (!(cart instanceof Cart)) {
        setErrorMessageAction(errorMessage);
        return null;
    }

    unsetErrorMessageAction();
    lockUi();
    shippingOptionsComputeRequest(cart)
    .then((result) => {
        unsetShippingOptionsAction();
        setShippingOptionsAction(result);
        unlockUi();
    })
    .catch(() => {
        setErrorMessageAction(errorMessage);
        unlockUi();
    });
}
